import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'

class CouponLists extends React.Component {
  state = {
    CouponLists: [],
  }
  componentDidMount() {
    this.CouponLists()
  }

  CouponLists = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/admin/list-coupons', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            CouponLists: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  deleteCoupon = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/admin/delete-coupon/${id}`, {
        headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then(() => {
        Swal.fire({
          title: 'Coupon Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.CouponLists()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, is_active) => {
    var data = { id, is_active }
    let that = this
    await axios
      .put(Constant.getAPI() + '/admin/coupon-status-update', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.CouponLists()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'coupon_code',
        label: 'Coupon code',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_desc',
        label: 'Coupon Description',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_amount',
        label: 'Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'amount_type',
        label: 'Amount Type',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_start_date',
        label: 'Start Date',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'user_allow_to_use',
        label: 'User Allow',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_for',
        label: 'Coupon For',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'number_of_user_use',
        label: 'Number of user',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_end_date',
        label: 'End Date',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[10]}
                checked={active === true ? true : false}
                value={active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[10], !active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/coupon/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <span
                  onClick={this.deleteCoupon.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{" "}
                </span> */}
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Category Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div>
        <div>
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Coupon List</h4>
                  </div>
                </div>
                <Link
                  to="/coupon/add"
                  className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                  data-modal="modal-13"
                >
                  {' '}
                  <i className="icofont icofont-plus m-r-5"></i> Add Coupon
                </Link>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title={'Coupon List'}
                        className="table-responsive"
                        data={this.state.CouponLists}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CouponLists
